export default {"src":"/_next/static/media/vogel.57d34159.svg","height":39,"width":225,"blurWidth":0,"blurHeight":0};